import React, { useState } from 'react'
import { Button, Modal, Form, Toast } from '@themesberg/react-bootstrap'

export default function ChargeUserResetPasswordModal({ show, chargeUser, onHide, onSubmit }) {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = async () => {
    setError('')
    if (!password || password.length < 6) {
      setError('Mật khẩu tối thiểu 6 ký tự')
      return
    }
    const result = await onSubmit(chargeUser.id, password)
    if (result?.error) {
      setError(result.message || 'Có lỗi xảy ra')
      return
    }
    setPassword('')
    onHide(true)
  }

  return (
    <Modal show={show} onHide={() => onHide(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Đổi mật khẩu user nạp tiền</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Toast show className="d-block mb-3" bg="danger">
            <Toast.Body className="text-white">{error}</Toast.Body>
          </Toast>
        )}
        <p className="small text-muted">{chargeUser?.username}</p>
        <Form.Group>
          <Form.Label>Mật khẩu mới</Form.Label>
          <Form.Control
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={6}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => onHide(false)}>
          Đóng
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Lưu
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
